import { isRecord } from "./type-guards";

/**
 * Guards the subset of Amplify REST errors this codebase relies on when
 * handling request failures.
 */
export type AmplifyError = {
  response: {
    status: number;
    statusCode?: number;
    statusText?: string;
    body?: string;
    data?: object;
  };
};

export function isAmplifyError(error: unknown): error is AmplifyError {
  if (!isRecord(error)) {
    return false;
  }
  if (!error.response) {
    return false;
  }
  if (!isRecord(error.response)) {
    return false;
  }
  return typeof error.response.status === "number";
}
